import { useCallback } from 'react';

import { AmountHelper } from 'modules/common/values';
import { Button, Field, TextInput } from 'modules/common/ui';

import { observer } from 'mobx-react';
import { FormRoot } from '../Form.Root';
import { Store } from '../../../stores';
import { FormButton, FormInput } from '../../Form';
import { schema } from '../PayForm.Schema';
import { PaymentType } from '../../../../repay';

const FormComponent = () => {
  const store = Store.use();

  const onPay = useCallback(
    (data: any) => {
      store.submitPayForm(
        AmountHelper.create(Number(data?.amount)),
        PaymentType.NEXT,
      );
    },
    [store],
  );

  const initialValues = {
    amount: String(AmountHelper.parse(store.amountMinimal)),
  };

  return (
    <FormRoot schema={schema} initialValues={initialValues} onSubmit={onPay}>
      <FormInput>
        <Field
          label="Сумма к оплате"
          htmlFor="amount"
          name="amount"
          error={store.errorMessage}
        >
          <TextInput id="amount" name="amount" disabled />
        </Field>
      </FormInput>
      <FormButton>
        <Button variant="filled" type="submit">
          Продолжить оплату
        </Button>
      </FormButton>
    </FormRoot>
  );
};

export const FormMin = observer(FormComponent);
